import Service, { service } from '@ember/service';

class OeeStateRepo extends Service {
  @service store;

  oeeStates = this.store.peekAll('oee-state');
}

export default OeeStateRepo;
